import { CHANGE_TIRE } from "../app-consts/appConstants";

export const getTireChangeServiceDetails = (state) => state.commonBenefits?.services?.find((service) => service.type === CHANGE_TIRE);

export const getServiceCoverageDetails = (state) => {
  const selectedService = state.serviceInfo?.serviceType;
  return state.commonBenefits?.services?.find((service: { type: any; }) => service.type === selectedService);
};